import { composeWithDevTools } from '@redux-devtools/extension';
import { DETECT_MUTATIONS } from 'config/app';
import { env } from 'config/env';
import {
  applyMiddleware,
  compose,
  legacy_createStore as createStore, // ! it's legacy, not deprecated. Redux as is will never be replaced by redux-toolkit.
  Store,
} from 'redux';
import mutationDetector from 'redux-immutable-state-invariant';
import createSagaMiddleware from 'redux-saga';
import Types from 'Types';

import rootReducer from './root-reducer';
import { rootSaga } from './root-saga';

const sagaMiddleware = createSagaMiddleware();

const middlewares =
  env.DEV && DETECT_MUTATIONS
    ? [sagaMiddleware, mutationDetector()]
    : [sagaMiddleware];

// In QA environments, we still want devtools

const enhancer = env.DEV
  ? composeWithDevTools(applyMiddleware(...(middlewares as any[])))
  : compose(applyMiddleware(...(middlewares as any[])));

function configureStore() {
  // Double cast: Redux 5's legacy_createStore has stricter types that don't
  // align with our typesafe-actions PayloadAction union. The runtime is correct.
  const store = createStore(rootReducer, enhancer as any) as unknown as Store<
    Types.RootState,
    Types.RootAction
  >;

  sagaMiddleware.run(rootSaga);

  return store;
}

export { configureStore };
